@if (historicalPositionService.selectedHistoricalDateTime()) {
  <dv-alert-banner
    [type]="'info'"
    [isVisible]="true"
    [title]="'FleetMap.HistoricalPositionEnabled' | translate"
    [contentText]="
      'FleetMap.PositionDateTime'
        | translate
          : {
              dateTime:
                historicalPositionService.selectedHistoricalDateTime()
                | date: 'dd.MM.yyyy HH:mm',
            }
    "
    [actionText]="'FleetMap.ResetHistoricalPosition' | translate"
    [actionFn]="bannerClickFn"></dv-alert-banner>
}
<app-map
  #map
  [id]="mapId"
  class="fleet-map"
  [ngClass]="
    historicalPositionService.selectedHistoricalDateTime()
      ? 'historical-position-enabled'
      : ''
  "
  [markers]="markers()"
  [invalidateSize$]="splitterEvents.resizeEnd$"
  [customTemplate]="{
    template: menuPanelTemplate,
    isFullScreenTemplate: false,
  }"
  [autoZoomFit$]="autoZoomFit$"
  [useMarkerClustering]="true"
  [toggleMarkerClustering$]="toggleMarkerClustering$"
  [deleteShapeTrigger$]="deleteGeofenceTrigger$"
  [shapeRightClickTrigger$]="shapeRightClickTrigger$"
  [shapes$]="geofences$"></app-map>

<ng-template #menuPanelTemplate>
  <app-timed-marker-map-menu-panel
    [mapSetting]="mapSetting"
    [customForm]="customSettingsForm"
    [customFormElements]="customSettingsElements"
    [disableMenu]="!!historicalPositionService.selectedHistoricalDateTime()"
    [showAddressSearch]="true"
    [markerGroupEnabled]="false"
    [showGeofenceLegend]="showGeofenceLegend()"
    [slideToggleLabel]="'TimedMarkerMenuForm.GeofenceToggle' | translate"
    (autoRefreshClicked)="onAutoRefreshClicked($event)"
    (autoZoomFitClicked)="onAutoZoomFitClicked($event)"
    (groupMarkersClicked)="onGroupMarkersClicked($event)"
    (searchAddressChanged)="onSearchAddressChanged($event)"
    (slideToggleClicked)="onGeofenceToggleClicked($event)"
    (customFormChanged)="onCustomSettingsChanged($event)">
    <app-historical-position-toggle></app-historical-position-toggle
  ></app-timed-marker-map-menu-panel>
  @if (searchResult$ | async; as addresses) {
    <app-address-search-result-box
      [addresses]="addresses"
      (addressSelected)="
        onAddressSelected($event)
      "></app-address-search-result-box>
  }
</ng-template>
